import React, { useEffect } from 'react';
import './index.css';

const captions = (props: any) => {

  useEffect(() => { }, []);

  return (
    <span
      className="subtitle"
      id={props.id}
      data-st={props.st}
      data-et={props.et}
    >
      {props.children}
    </span>
  );
};

export default captions;
